import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import classes from './ScreenShot.module.css';
export const ScreenShot = ({ screenShot, backgroundElement, }) => {
    const [fullScreen, setFullScreen] = useState(false);
    return (_jsxs("div", Object.assign({ className: classes.container }, { children: [backgroundElement && (_jsx("div", Object.assign({ className: classes.background, role: "none", "data-screenshot-bg": true }, { children: backgroundElement }))), _jsx("button", Object.assign({ type: "button", title: fullScreen ? 'minimize' : 'maximize', className: fullScreen
                    ? `${classes.wrapper} ${classes.fullScreen}`
                    : classes.wrapper, onClick: () => setFullScreen(!fullScreen) }, { children: screenShot }))] })));
};
